import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarMenuService {
  private isSidebarOpenSignal = signal<boolean>(false);
  private isNavBtnSelectedSignal = signal<boolean>(false);
  readonly activeItem = signal<string | null>(null);
  /** Texto de búsqueda para filtrar los ítems del menú lateral. */
  readonly menuFilter = signal<string>('');

  private readonly LOCAL_STORAGE_KEY = 'sidebarOpen';

  isSidebarOpen(): boolean {
    return this.isSidebarOpenSignal();
  }

  isNavBtnSelected(): boolean {
    return this.isNavBtnSelectedSignal();
  }

  loadFromLocalStorage(): void {
    const saved = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (saved) {
      this.isNavBtnSelectedSignal.set(saved === 'true');
    }
    this.setSidebarOpen(this.isNavBtnSelectedSignal());
  }

  setSidebarOpen(isSidebarOpen: boolean): void {
    this.isSidebarOpenSignal.set(isSidebarOpen);
    if (!isSidebarOpen) {
      this.menuFilter.set('');
    }
  }

  setIsNavBtnSelected(isNavBtnSelected: boolean): void {
    this.isNavBtnSelectedSignal.set(isNavBtnSelected);
    localStorage.setItem(this.LOCAL_STORAGE_KEY, isNavBtnSelected.toString());
  }

  clearActiveItem(): void {
    this.activeItem.set(null);
  }

  setMenuFilter(filter: string): void {
    this.menuFilter.set(filter);
  }

  clearMenuFilter(): void {
    this.menuFilter.set('');
  }
}
